











import { Component, Provide, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import SearchBar from './components/common/search_bar.vue'
import { allowRefreshOrShare, getSelectedCityId } from '@utils/index'

window._TRACK_EXPOSURE = true 
const searchModule = namespace('search') //vuex

@Component({
  components: {
    'search-bar': SearchBar,
    'search-history': () => import('./components/search/history.vue'),
    'search-hot': () => import('./components/search/hot.vue'),
    'search-rank': () => import('./components/search/rank.vue'),
  },
})
export default class Search extends Vue {
  searchKey = ''

  //vuex 声明
  @searchModule.State search!: any
  @searchModule.Action getSearchAction!: (par: { navid: string | number }) => Promise<any>

  created() {
    this.$setTitle('搜索')
    this.$tracker('127', '121012975')()
    allowRefreshOrShare(false, false)
  }

  @Provide()
  onSearchEP = (params = {}) => {
    return `200001||${JSON.stringify({...params})}`
  }
  onSearch(key: string) {
    this.$newClickTracker({ bizType: '127', pageLevelId: '121012975', clickId: '200001', pageParam: { citycode: getSelectedCityId() }, positionParam: { keyword: key } })
  }

  @Provide()
  useHistoryEP = (params = {}) => {
    return `200004||${JSON.stringify({...params})}`
  }
  useHistory(item: any) {
    const { keyword } = item
    this.searchKey = keyword
    this.$newClickTracker({ bizType: '127', pageLevelId: '121012975', clickId: '200004', pageParam: { citycode: getSelectedCityId() }, positionParam: { keyword: keyword } })
  }

  @Provide()
  useHotEP = (params = {}) => {
    return `200002||${JSON.stringify({...params})}`
  }
  useHot(item: any) {
    const { keyword } = item
    this.searchKey = keyword
    this.$newClickTracker({ bizType: '127', pageLevelId: '121012975', clickId: '200002', pageParam: { citycode: getSelectedCityId() }, positionParam: { keyword: keyword } })
  }

  @Provide()
  useRankEP = (params = {}) => {
    return `200003||${JSON.stringify({...params})}`
  }
  useRank(item: any) {
    this.$newClickTracker({ bizType: '127', pageLevelId: '121012975', clickId: '200003', pageParam: { citycode: getSelectedCityId() }, positionParam: { link: item.link, name: item.title } })
  }
}
